<template>
  <div
    class="online flex flex-right flex-middle"
    :style="{
      background: `white url(${bg}) no-repeat`,
      backgroundSize: 'auto 100%',
      backgroundPosition: '10% center',
    }"
  >
    <div class="online-inner">
      <div class="flex flex-row">
        <div class="online-num" v-for="(item, index) in numString" :key="index">
          {{ item }}
        </div>
      </div>
      <div class="online-title">{{ title }}</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Number,
      default: null,
    },
    title: {
      type: String,
      default: "",
    },
    bg: {
      type: String,
      default: "",
    },
    bgSize: {
      type: String,
      default: "",
    },
    bgPos: {
      type: String,
      default: "",
    },
  },
  computed: {
    numString() {
      return `${this.data}`.split("");
    },
  },
};
</script>
<style lang="scss" scoped>
.online {
  width: 390px;
  height: 198px;
  background: #ffffff;
  border-radius: 16px;
  margin-bottom: 30px;
  text-align: center;
  padding-right: 20px;
  &-num {
    width: 40px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    background: #6ca5f8;
    border-radius: 4px;
    color: white;
    font-size: 18px;
    font-weight: bold;
    margin-right: 15px;
  }
  &-title {
    padding-top: 20px;
    font-weight: bold;
    font-size: 15px;
  }
}
</style>
